import $ from 'jquery';
import { initScrollToTop } from './components/common/scrollToTop';
import { initYoutubeVideos } from './components/common/youtube';
import { init360ViewEvent, initProductGallery, initProductGalleryDialog } from './components/product/product-gallery';
import { initProductCombination, initProductCombinationTab } from './components/product/product-utils';
import { initLoadingSpinner } from './components/loading-spinner';

import './components/product/tab-product';
import './components/product/add-to-cart-bottom';

import './components/common/accordion';
import './components/common/features-swiper';
import './components/common/video-slider';
import './components/features';
import './components/product/product-popup';
import './components/common/cross-selling';

$(() => {
  let updateEventType = false;

  initProductGallery();
  initYoutubeVideos();

  prestashop.on('updatedProductCombination', () => {
    initProductGallery();
    initProductGalleryDialog();
    init360ViewEvent();
    initProductCombinationTab();
    updateBottomPrice();
  });

  prestashop.on('updateProduct', ({ eventType }) => {
    initLoadingSpinner('.swiper-thumbs .swiper-slide-visible');
    initLoadingSpinner('.product-cover');
    updateEventType = eventType;
  });

  prestashop.on('updatedProduct', event => {
    if (updateEventType === 'updatedProductCombination') {
      $('.js-product-images').replaceWith(event.product_cover_thumbnails);
      prestashop.emit('updatedProductCombination', event);
    }

    updateEventType = false;
  });

  initProductCombination();
  init360ViewEvent();
  initProductGalleryDialog();
  initScrollToTop();
  initProductCombinationTab();
});

function updateBottomPrice() {
  let priceTop = $('.product-prices-section .product-prices').html();
  $('.product-actions-bottom .product-prices').html(priceTop);
}
